"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCxIdentifier = exports.isIOS = exports.isMshop = exports.isMobile = void 0;
const monera_app_core_1 = require("@amzn/monera-app-core");
const constants_1 = require("@amzn/monera-app-core/lib/constants");
const device_1 = require("@amzn/monera-app-core/lib/models/device");
const isMobile = (deviceType) => {
    if (!deviceType) {
        return false;
    }
    return deviceType === monera_app_core_1.DeviceType.Mobile || deviceType === monera_app_core_1.DeviceType.MShop;
};
exports.isMobile = isMobile;
const isMshop = (deviceType) => {
    if (!deviceType) {
        return false;
    }
    return deviceType === monera_app_core_1.DeviceType.MShop;
};
exports.isMshop = isMshop;
const isIOS = (platformType) => {
    if (!platformType) {
        return false;
    }
    return platformType === device_1.PlatformType.Ios;
};
exports.isIOS = isIOS;
const getCxIdentifier = (configRegistryState, shoppingPortalRegistryState, weblabStoreState) => {
    const asin = configRegistryState.asin;
    const locale = configRegistryState.locale;
    const marketplaceId = shoppingPortalRegistryState.marketplaceId;
    const enabledTreatments = Object.keys(weblabStoreState.weblabTreatments || {})
        .filter((key) => weblabStoreState.weblabTreatments[key])
        .join('/');
    const cxIdentifierTemplate = constants_1.CX_IDENTIFIER_TEMPLATE;
    if (!cxIdentifierTemplate) {
        return;
    }
    const cxIdentifier = cxIdentifierTemplate
        .replace('{asin}', asin)
        .replace('{locale}', locale)
        .replace('{marketplaceId}', marketplaceId)
        .replace('{enabledTreatments}', enabledTreatments);
    return cxIdentifier;
};
exports.getCxIdentifier = getCxIdentifier;
